import { COLUMN_SIZE } from '../DataGridDevEx/DataGrid.constants';

export const getPurchaseOrderLookupColumns = () => [
    {
        dataField: 'Code',
        caption: 'Purchase order',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: true
    },
    {
        dataField: 'Details.Entity',
        caption: 'Entity',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'Details.Created',
        caption: 'Created',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: false
    },
    {
        dataField: 'Details.StatusLabel',
        caption: 'Status',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: false
    },
    {
        dataField: 'Details.Type',
        caption: 'Type',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
    {
        dataField: 'Details.Name',
        caption: 'Name',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: false
    }
];
export const getPurchaseOrderLookupSearchColumns = () => [
    {
        dataField: 'Code',
        caption: 'Purchase order',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: true
    },
    {
        dataField: 'Details.Entity',
        caption: 'Entity',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: true
    },
    {
        dataField: 'Details.Created',
        caption: 'Created',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: false
    },
    {
        dataField: 'Details.StatusLabel',
        caption: 'Status',
        allowResizing: true,
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.md1,
        fixed: false
    },
    {
        dataField: 'Details.Type',
        caption: 'Type',
        allowResizing: true,
        minWidth: COLUMN_SIZE.lg0,
        width: COLUMN_SIZE.lg0,
        fixed: false
    },
    {
        dataField: 'Details.Name',
        caption: 'Name',
        allowResizing: true,
        minWidth: COLUMN_SIZE.MatchTypeField,
        width: COLUMN_SIZE.MatchTypeField,
        fixed: false
    }
];
export const SEARCH_SCREEN_DIALOG_STYLE = {
    width: 'calc(71%)',
    maxWidth: 'calc(71%)',
    height: 'calc(100% - 300px)',
    maxHeight: 'calc(100% - 300px)',
};
